/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './animation027.less';

interface IAnimation027Item {
  text: string;
  title: string;
  color: string;
}

interface IAnimation027Props {
  items: IAnimation027Item[];
  tip: string;
  className?: string;
  onCompleted?: () => void;
}

const Animation027: React.FunctionComponent<IAnimation027Props> = ({
  items,
  tip,
  className,
  onCompleted,
}) => {
  return (
    <div className={`animation027 component ${className || ''}`}>
      {tip && (
        <div className="animation027-tip">
          <div className="tip" dangerouslySetInnerHTML={{ __html: tip }} />
        </div>
      )}
      <div className="animation027-content">
        {items.map((itm: IAnimation027Item, idx: number) => (
          <>
            <div key={idx} className="animation027-item">
              <div
                className="animation027-color-div"
                style={{ backgroundColor: itm.color }}
              >
                <div
                  className="animation027-title"
                  dangerouslySetInnerHTML={{ __html: itm.title }}
                  style={{ backgroundColor: itm.color }}
                />
              </div>
              <div
                className="animation027-text"
                dangerouslySetInnerHTML={{ __html: itm.text }}
              />
            </div>
          </>
        ))}
      </div>
    </div>
  );
};

export default Animation027;
